// This file was generated by org.multipaz.processor.CodeBuilder, do not edit by hand
package org.multipaz.wallet.client

import org.multipaz.cbor.DataItem
import org.multipaz.wallet.client.WalletClientSharedData
import org.multipaz.cbor.Cbor
import kotlinx.io.bytestring.ByteString
import org.multipaz.cbor.annotation.CborSerializableGenerated
import org.multipaz.cbor.CborMap
import org.multipaz.cbor.buildCborArray
import org.multipaz.cbor.Bstr
import org.multipaz.wallet.client.WalletClientProvisionedDocument
import org.multipaz.cbor.Tstr
import org.multipaz.wallet.client.toDataItem
import org.multipaz.wallet.client.fromDataItem

fun WalletClientSharedData.toCbor(): ByteArray {
    return Cbor.encode(toDataItem())
}

@CborSerializableGenerated(schemaId = "baOfBCilzugVA7pWjYFlsTqC3mti3dfwpvQiuXSh0fI")
val WalletClientSharedData_cborSchemaId = ByteString(109, -93, -97, 4, 40, -91, -50, -24, 21, 3, -70, 86, -115, -127, 101, -79, 58, -126, -34, 107, 98, -35, -41, -16, -90, -12, 34, -71, 116, -95, -47, -14)

fun WalletClientSharedData.Companion.fromCbor(data: ByteArray): WalletClientSharedData {
    return WalletClientSharedData.fromDataItem(Cbor.decode(data))
}

val WalletClientSharedData.Companion.cborSchemaId: ByteString
    get() = WalletClientSharedData_cborSchemaId

fun WalletClientSharedData.toDataItem(): DataItem {
    val builder = CborMap.builder()
    val encodedMpzPasses = this.encodedMpzPasses
    if (encodedMpzPasses != null) {
        val array = encodedMpzPasses.let {
            buildCborArray {
                for (value in it) {
                    add(Bstr(value.toByteArray()))
                }
            }
        }
        builder.put("encodedMpzPasses", array)
    }
    val provisionedDocuments = this.provisionedDocuments
    if (provisionedDocuments != null) {
        val array0 = provisionedDocuments.let {
            buildCborArray {
                for (value in it) {
                    add(value.toDataItem())
                }
            }
        }
        builder.put("provisionedDocuments", array0)
    }
    val documentOrder = this.documentOrder
    if (documentOrder != null) {
        val array1 = documentOrder.let {
            buildCborArray {
                for (value in it) {
                    add(Tstr(value))
                }
            }
        }
        builder.put("documentOrder", array1)
    }
    return builder.end().build()
}

fun WalletClientSharedData.Companion.fromDataItem(dataItem: DataItem): WalletClientSharedData {
    val encodedMpzPasses0 = if (dataItem.hasKey("encodedMpzPasses")) {
        val array2 = dataItem["encodedMpzPasses"].let {
            buildList<ByteString> {
                for (value in it.asArray) {
                    add(ByteString(value.asBstr))
                }
            }
        }
        array2
    } else {
        null
    }
    val provisionedDocuments0 = if (dataItem.hasKey("provisionedDocuments")) {
        val array3 = dataItem["provisionedDocuments"].let {
            buildList<WalletClientProvisionedDocument> {
                for (value in it.asArray) {
                    add(WalletClientProvisionedDocument.fromDataItem(value))
                }
            }
        }
        array3
    } else {
        null
    }
    val documentOrder0 = if (dataItem.hasKey("documentOrder")) {
        val array4 = dataItem["documentOrder"].let {
            buildList<String> {
                for (value in it.asArray) {
                    add(value.asTstr)
                }
            }
        }
        array4
    } else {
        null
    }
    return WalletClientSharedData(
        encodedMpzPasses = encodedMpzPasses0,
        provisionedDocuments = provisionedDocuments0,
        documentOrder = documentOrder0,
    )
}
